(() => {
  const original = new Map();
  let timer;
  let running = false;
  const eligible = element => element instanceof HTMLElement && !['SCRIPT','STYLE','LINK','META','NOSCRIPT','IFRAME','CANVAS'].includes(element.tagName) && !element.closest('svg,[data-sp-keep-text-size]');
  const apply = () => {
    if (running || !document.body) return;
    running = true;
    for (const [element, previous] of original) {
      if (!element.isConnected) { original.delete(element); continue; }
      if (previous.value) element.style.setProperty('font-size', previous.value, previous.priority);
      else element.style.removeProperty('font-size');
    }
    const elements = Array.from(document.body.querySelectorAll('*')).filter(eligible);
    const sizes = elements.map(element => {
      if (!original.has(element)) original.set(element, {value:element.style.getPropertyValue('font-size'),priority:element.style.getPropertyPriority('font-size')});
      return parseFloat(getComputedStyle(element).fontSize);
    });
    elements.forEach((element, index) => {
      if (!Number.isFinite(sizes[index]) || sizes[index] === 0) return;
      element.style.setProperty('--sp-font-base', sizes[index] + 'px');
      let size = sizes[index] * 1.518;
      if (element.closest('.sp-home-hero')) size = Math.max(size * 1.15, sizes[index] < 24 ? 21.6 : 0);
      else if (element.closest('.sp-announcement')) size = Math.max(size * 1.18, 19.2);
      else if (element.closest('.sp-header')) size = Math.max(size * 1.12, 19.2);
      else if (element.closest('.sp-payment-promise,.sp-promise-bar')) size = Math.max(size * 1.12, 18);
      element.style.setProperty('font-size', size.toFixed(3) + 'px', 'important');
    });
    document.body.dataset.spTextScale = '1.518';
    running = false;
  };
  const schedule = () => { clearTimeout(timer); timer = setTimeout(apply, 120); };
  const start = () => {
    apply();
    new MutationObserver(changes => {
      if (changes.some(change => change.addedNodes.length || change.removedNodes.length)) schedule();
    }).observe(document.body, {childList:true,subtree:true});
    window.addEventListener('resize', schedule, {passive:true});
    window.addEventListener('pageshow', schedule);
    if (document.fonts) document.fonts.ready.then(schedule);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();
